import styled from 'styled-components';

interface ParagraphStyledProps {
  fontSize: number;
}

const TagStyled = styled.span<ParagraphStyledProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 14px;
  border-radius: 24px;
  background: #f1f1f1;
  color: #666666;
  transition: all 0.2s ease-out;
  font-size: ${({ fontSize }) => fontSize}px;

  :hover {
    cursor: pointer;
  }

  &.active {
    background: ${({ theme }) => theme.primaryColor};
    color: ${({ theme }) => theme.white};
  }
`;

export default TagStyled;
export { TagStyled };
